import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import ContentEdit, { Header, Detail, Side } from './ContentEdit';
import {
  TimecardsFilter,
  TimecardDialog,
  TimecardsCards,
  TimecardsCardsSide,
} from './Timecards';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
    marginLeft: theme.spacing.unit*4,
  },
});

class TimecardsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showDialog: false,
      dialogType: undefined,
      timecard: undefined,
    }
  }

  render() {
    const { classes, theme } = this.props;
    const { showDialog, dialogType, timecard } = this.state;

    return(
      <div className={classes.root}>
        {showDialog &&
          <TimecardDialog
            show={showDialog}
            type={dialogType}
            timecardData={timecard}
            handleClose={() => this.setState({showDialog: false, dialogType: undefined, timecard: undefined})}
          />
        }
        <ContentEdit>
          <Header theme={theme}>
            <TimecardsFilter handleAdd={() => this.setState({showDialog: true, dialogType: "add", timecard: undefined})} />
          </Header>
          <Detail theme={theme}>
            <TimecardsCards
              handleEdit={(timecard) => {
                this.setState({showDialog: true, dialogType: "edit", timecard: timecard})}
              }/>
          </Detail>
          <Side theme={theme}>
            <Tooltip type={TooltipTypes.timecard.INFO_PANEL} placement="left-bottom">
              <TimecardsCardsSide />
            </Tooltip>
          </Side>
        </ContentEdit>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(TimecardsPage);



// WEBPACK FOOTER //
// ./src/components/admin/TimecardsPage.jsx